import { render, staticRenderFns } from "./OutstandingInvoiceDetail.vue?vue&type=template&id=7f051c50&"
import script from "./OutstandingInvoiceDetail.vue?vue&type=script&lang=ts&"
export * from "./OutstandingInvoiceDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports